import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { APIService } from '../services/apiService';
import { ROUTES } from '../constants';
import { ApplicationHeadDTO } from '../DTO/ApplicationHeadDTO';
import {
	Button,
	Card,
	Container,
	FormGroup,
	IconButton,
	TextField,
	Typography,
	Alert,
	AlertTitle,
} from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import EditIcon from '@mui/icons-material/Edit';
import { appStatusName } from '../util/enumerations';

const margin = {
	marginBottom: '12px',
	marginRight: '12px',
};
const api = new APIService();

const Applications = () => {
	const navigate = useNavigate();
	const [applications, setApplications] = useState<
		ApplicationHeadDTO[] | null
	>(null);
	const [newClicked, setNewClicked] = useState<boolean>(false);

	const getApplications = () => {
		api.getApplications().then((data) => setApplications(data));
	};

	const createApplication = () => {
		if (!newClicked && (applications || []).length > 0) {
			setNewClicked(true);
		} else {
			navigate(ROUTES.CREATE_APPLICATION);
		}
	};
	useEffect(() => {
		getApplications();
	}, []);

	if (!applications) return <p>Hämtar ansökningar...</p>;

	return (
		<>
			{newClicked && applications?.length ? (
				<Alert severity="warning">
					<AlertTitle>Warning</AlertTitle>
					You already have an active application —{' '}
					<strong> are you sure you want to continue?</strong>
				</Alert>
			) : null}
			<Container style={{ textAlign: 'center' }}>
				<Button
					variant="contained"
					color="secondary"
					size="large"
					style={{ margin: '20px' }}
					onClick={(e) => createApplication()}
					startIcon={<AddCircleOutlineIcon />}
				>
					New application
				</Button>
				{applications.length > 0 &&
					applications.map((a) => (
						<Card
							key={a.id}
							elevation={5}
							style={{
								padding: '10px',
								marginBottom: '20px',
								marginTop: '10px',
							}}
						>
							<Typography variant="h5" style={{ margin: '10px' }}>
								{`Application ${a.id}`}
							</Typography>
							<FormGroup
								row
								style={{
									display: 'flex',
									justifyContent: 'center',
								}}
							>
								<TextField
									type="text"
									value={a?.school?.name}
									label="School"
									disabled={true}
									style={margin}
								/>
								<TextField
									type="text"
									value={a?.school?.country?.name}
									label="Country"
									style={margin}
									disabled={true}
								/>
								<TextField
									type="text"
									value={a?.year}
									label="Year"
									style={margin}
									disabled={true}
								/>
								<TextField
									type="text"
									value={appStatusName(a?.status)}
									label="Status"
									style={margin}
									disabled={true}
								/>
							</FormGroup>
							<Link
								to={`${ROUTES.APPLICATION}/${a.id}`}
								key={a.id}
								className="no-link-style"
							>
								<IconButton aria-label="delete" color="primary">
									<EditIcon fontSize="large" />
								</IconButton>
							</Link>
						</Card>
					))}
			</Container>
		</>
	);
};

export default Applications;
